import SceButton from  "../../../../../Common/CommonComponents/sceButton";
import {getLocalizedStringstwo} from'../../twoFactorAuthenticationStrings';
import classes from '../../TwoFactorAuth.scss';

function EmailStepOne(props) {
  let strings = getLocalizedStringstwo('TwoFactorAuthentication');

  return (
    <div className={classes.card}>
    <div className={classes.btnsPadding}>
     <div className={classes.contentContainer}>  <div className={[classes.verifyLogIn, 'sce-center-alg'].join(" ")}> {strings.VerifyYourEmailAddress}
        <div className={["sce-content-row", classes.verifyAddress].join(" ")}> {props.maskedValue} </div>
      </div>
        <div className={["sce-content-row", classes.subText].join(" ")}>  {strings.verifyEmailTxt} </div>
        <div className={['sce-center-alg',"sce-content-row"].join(" ")}>
          <SceButton
            value={strings.sendCode}
            id="twoFA_sendcode"
            name='email'            
            onClick={props.sendCodeHandler}
            isDisabled={(props.disableSendCodeBtn) ? true : false} 
            buttonType={(props.disableSendCodeBtn) ?'sceBtnDisabledPrimary' : 'primary'}
          />
        </div>
      </div>
       
    </div>
    </div>
  );
}

export default EmailStepOne;
